import type { ReactNode } from "react"

export interface Props {
  children: ReactNode
}

const AccordionGroup = ({ children }: Props) => {
  return <div className="flex flex-col gap-4">{children}</div>
}

AccordionGroup.displayName = "AccordionGroup"

export { AccordionGroup }
export default AccordionGroup
